export enum UserRoles {
  Admin = 'Admin',
  User = 'User',
  Staff = 'Staff',
}
